<template>
  <div class="h-auto">
    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>
    <div class="bg-white m-3">
      <!-- TAB FOR DYNAMIC LEAVE TYPES -->
      <el-tabs
        type="border-card"
        v-model="activeTab"
        @tab-click="getLeaveSummary"
      >
        <el-tab-pane
          v-for="(stat, index) in MyLeaveTypeStats"
          :key="index"
          :label="stat.LeaveTypeName"
          :id="stat.LeaveTypeId"
        >
        </el-tab-pane>
      </el-tabs>
      <!-- END FOR DYNAMIC LEAVE TYPES -->
      <!-- {{ currentTabBalances }}  -->
      <div>
        <section class="flex items-end w-full my-2 justify-end">
          <el-select v-model="selectedYear" placeholder="Select period">
            <el-option
              v-for="period in periods"
              :key="period.Id"
              :label="period.PeriodName.toString()"
              :value="period.Id"
            >
            </el-option>
          </el-select>
        </section>

        <ve-table :columns="balancesColumns" :tableData="currentTabBalances">
        </ve-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";

import { Tabs, TabPane } from "element-ui";

import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "MyTimeOff",
  components: {
    "el-tabs": Tabs,
    "el-tab-pane": TabPane,
    Loader,
  },
  data() {
    return {
      periods: [],
      selectedYear: null,
      attachmentUrl: "",
      showRequestLeave: false,
      showLocCrSuccess: false,
      showAttachments: false,
      showReviewLeave: false,
      approvalEntries: null,
      leaveDetails: null,
      success: null,
      showEditRequest: false,
      requestToEdit: null,
      successMessage: "Leave has been requested successfully!",
      loading: false,
      reload: false,
      MyLeaveTypes: [],
      currentTab: "Approved",
      selectedTab: "",
      searchInput2: "",
      searchInput: "",
      MyLeaveTypeStats: [],
      activeTab: 0,
      cancel_error: null,
      cancel_success: null,
      currentTabBalances: [],
      // teamKey: 0,
      // mineKey: 1,

      tabs: [
        {
          name: "Approved",
          route: "mine",
        },
        {
          name: "Declined",
          route: "team",
        },
      ],

      balancesColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Days",
          key: "Days",
          title: "Days",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) =>
            row.Days > 0 ? (
              <p class="text-green-500 font-bold text-sm">{row.Days}</p>
            ) : (
              <p class="text-red-500 font-bold text-sm">{row.Days}</p>
            ),
        },
      ],

      balances: [],

      tableData2: [],
      // Work on this
      expandOption: {
        trigger: "row",
        render: ({ row }) => {
          return (
            <table class="table-auto w-full p-2">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Line Manager</th>
                </tr>
              </thead>
              <tbody>
                {row.map((row) => {
                  row;
                  return (
                    <tr class="text-center">
                      <td>Description</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        },
        beforeExpandRowChange: () => {
          // alert(JSON.stringify(row, rowIndex));
          // this.getDepartments(row.Id, rowIndex);
        },
      },
      // Work on this

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "LeaveType",
          key: "x",
          title: "Type",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <div
              class="cursor-pointer text-blue-500"
              onClick={() => {
                this.attachmentUrl = row.Attachment;
                this.approvalEntries = row.ApprovalEntries;
                this.leaveDetails = row;
                this.showReviewLeave = true;
                this.showAttachments = true;
              }}
            >
              {row.LeaveType}
            </div>
          ),
        },
        {
          field: "StartDate",
          key: "a",
          title: "From",
          width: 160,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.StartDate)}</p>
          ),
        },
        {
          field: "EndDate",
          key: "b",
          title: "To",
          width: 160,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.EndDate)}</p>
          ),
        },
        { field: "Period", key: "c", title: "Days" },

        {
          field: "Description",
          key: "d",
          title: "Description",
          headerAlign: "left",
          align: "left",
        },

        {
          field: "Status",
          key: "g",
          title: "Status",
          renderBodyCell: ({ row }) => {
            let status = "";

            switch (row.Status) {
              case "Approved":
                status = (
                  <p class="cursor-pointer text-green-500"> {row.Status}</p>
                );
                break;

              case "Pending":
                status = (
                  <p class="cursor-pointer text-blue-500">{row.Status}</p>
                );
                break;
              case "Declined":
                status = <p class="cursor-pointer text-red">{row.Status}</p>;
                break;
            }
            return status;
          },
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleCancelButtonClick(row)}
                >
                  Cancel
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserType",
      "getCurrentEmployeeId",
      "getVersion",
      "getUserToView",
    ]),

    filteredColumns() {
      const approvedCount = this.leaves.filter(
        (leave) => leave.Status === "Approved"
      ).length;
      const declinedCount = this.leaves.filter(
        (leave) => leave.Status === "Declined"
      ).length;

      return this.columns.filter((column) => {
        if (
          column.field === "Action" &&
          (approvedCount === this.leaves.length ||
            declinedCount === this.leaves.length)
        ) {
          return false;
        }
        return true;
      });
    },
  },

  created() {
    this.getPeriods();
  },
  mounted() {
    if (this.MyLeaveTypeStats.length > 0) {
      this.getPeriods();
    }
  },
  watch: {
    MyLeaveTypeStats: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.getLeaveSummary();
        }
      },
      immediate: true, // Invoke the handler immediately when the component is created
    },

    selectedYear() {
      this.getMyLeaveSummary();
    },
  },
  methods: {
    async getPeriods() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/setup/leave/period/${this.$ApiVersion}/request`,
          options
        );

        this.loading = false;

        if (response.data.StatusCode === 200) {
          this.periods = response.data.Data.sort((a, b) => parseInt(a.PeriodName) - parseInt(b.PeriodName));

          this.selectedYear = this.periods[this.periods.length - 1].Id;
          this.getMyLeaveSummary();
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },
    formatLeaveTypeStats(stats) {
      return Object.entries(stats).map(([key, value]) => {
        const name = key.split(/(?=[A-Z])/).join(" ");
        const days = value;
        return { Name: name, Days: days };
      });
    },

    // /{organization}/timeoff/leave/type/{leaveTypeId}/v1/summary
    getMyLeaveSummary() {
      this.loading = true;
      const employeeId = this.getCurrentEmployeeId;
      const periodId = this.selectedYear;

      const url = `${this.getOrganization}/employee/timeoff/v1/balance?employeeId=${employeeId}&periodId=${periodId}`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.tableData = response.data.Data;
            this.MyLeaveTypeStats = response.data.Data;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.error = error.message;
        }
      );
    },

    getLeaveSummary() {
      // Get the current tab's leave type summary and format it
      this.currentTabBalances = this.formatLeaveTypeStats(
        this.MyLeaveTypeStats[this.activeTab].Summary
      );

      // Find the Pending Approval and Available entries
      let pendingApproval = this.currentTabBalances.find(
        (entry) => entry.Name === "Pending Approval"
      );
      let available = this.currentTabBalances.find(
        (entry) => entry.Name === "Available"
      );

      // Add Pending Approval days to Available days if both exist
      if (pendingApproval && available) {
        available.Days += pendingApproval.Days;
      }
    },
    formatDate(dateStr) {
      return moment(dateStr).format("DD/MM/YYYY");
    },

    sortLeaves(a, b) {
      const aLeaveType = a.LeaveType.toLowerCase();
      const bLeaveType = b.LeaveType.toLowerCase();

      if (aLeaveType.includes("annual") && !bLeaveType.includes("annual")) {
        return -1; // "Annual Leave" comes first
      } else if (
        !aLeaveType.includes("annual") &&
        bLeaveType === "annual leave"
      ) {
        return 1; // "Annual Leave" comes first
      }

      return aLeaveType.localeCompare(bLeaveType); // Sort alphabetically
    },
  },
};
</script>

<style>
.el-tabs__item.is-top.is-active {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: "#fff" !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #fff;
}

.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #fff;
}

.el-tabs__item.is-top:hover {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
}
</style>
